namespace Matrix.Data {
    export class ModelColumns {
        static columnsKey = 'Data.Model';
    }
}
